/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OrderIncompleteDeliveryReason = {
    ItemsMissing: 'ITEMS_MISSING',
    ItemDamaged: 'ITEM_DAMAGED',
    Other: 'OTHER'
} as const;
export type OrderIncompleteDeliveryReason = typeof OrderIncompleteDeliveryReason[keyof typeof OrderIncompleteDeliveryReason];


// @ts-ignore
export function OrderIncompleteDeliveryReasonFromJSON(json: any): OrderIncompleteDeliveryReason {
    return OrderIncompleteDeliveryReasonFromJSONTyped(json, false);
}

// @ts-ignore
export function OrderIncompleteDeliveryReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderIncompleteDeliveryReason {
    return json as OrderIncompleteDeliveryReason;
}

// @ts-ignore
export function OrderIncompleteDeliveryReasonToJSON(value?: OrderIncompleteDeliveryReason | null): any {
    return value as any;
}

